export default __webpack_public_path__ + "static/media/logo_white.71183bb2.png";